import ApplicationController from "../application_controller";

export default class RecaptchaController extends ApplicationController {
  static targets = ["token", "action"];
  static values = { sitekey: String };

  declare readonly tokenTarget: HTMLInputElement;
  declare readonly actionTarget: HTMLInputElement;
  declare sitekeyValue: string;

  retrieveToken(event: StimulusEvent) {
    const promise = new Promise<void>((resolve) => {
      grecaptcha.enterprise.ready(async () => {
        this.tokenTarget.value = await grecaptcha.enterprise.execute(this.sitekeyValue, {
          action: this.actionTarget.value,
        });
        resolve();
      });
    });
    event.detail.promises.push(promise);
  }
}
